var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.sort(_vm.field, 'DESC')}}},[_vm._v("↓")]),_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.sort(_vm.field, 'ASC')}}},[_vm._v("↑")])])
}
var staticRenderFns = []

export { render, staticRenderFns }